import { BaseContainerModel } from '../../base-container.model';
import {bl_fi_cashbook_imported_file_ext_RowClass, bl_fi_cashbook_imported_file_hdr_RowClass,bl_fi_cashbook_imported_file_line_RowClass}
from '../../../dbschema/index';

export class CashbookImportContainerModel extends BaseContainerModel {
  bl_fi_cashbook_imported_file_hdr: bl_fi_cashbook_imported_file_hdr_RowClass = new bl_fi_cashbook_imported_file_hdr_RowClass();
  bl_fi_cashbook_imported_file_ext: bl_fi_cashbook_imported_file_ext_RowClass[] = [];
  bl_fi_cashbook_imported_file_lines: bl_fi_cashbook_imported_file_line_RowClass[] = [];
  }